import React from 'react';

const SNEAKER_TALL = '/assets/img/sneaker-hero-tall.jpg';
const SNEAKER_TALL_WEBP = '/assets/img/sneaker-hero-tall.webp';
const SNEAKER_XWIDE = '/assets/img/sneaker-hero-xwide.jpg';
const SNEAKER_XWIDE_WEBP = '/assets/img/sneaker-hero-xwide.webp';

/**
 * Right side — ALL DESIGN STUDIO.
 *
 * Two crops of the same shot:
 *   • sneaker-hero-xwide (3:2, 1264x848) — DESKTOP ≥861px. Extended
 *     landscape crop with WIDE greige margins on both sides. This is the
 *     key to making `object-fit: cover` work at any viewport aspect
 *     ratio (16:9, 16:10, 4:3, 2K, …) — the cover crop always keeps the
 *     sneaker composition centered, only the greige margin is cropped.
 *     No more contain-fallback with sand fill.
 *   • sneaker-hero-tall (2:3, 848x1264) — MOBILE <861px. Portrait crop
 *     for the vertically-stacked mobile band.
 *
 * iter86 · WebP served as primary, JPEG kept as fallback for legacy
 * browsers (Safari <14, IE). Saves ~80% on both crops (LCP on mobile
 * drops from 614KB → 122KB, on desktop from 500KB → 100KB).
 */
export default function AllDesignSide() {
    return (
        <div className="side-media side-media--alldesign" data-testid="alldesign-media">
            <picture>
                {/* Desktop: xwide WebP preferred, JPEG fallback */}
                <source
                    media="(min-width: 861px)"
                    type="image/webp"
                    srcSet={SNEAKER_XWIDE_WEBP}
                />
                <source
                    media="(min-width: 861px)"
                    srcSet={SNEAKER_XWIDE}
                />
                {/* Mobile: tall WebP preferred, JPEG fallback via <img src>.
                    iter88 · media="(max-width: 860px)" ALIGNS with the
                    <link rel="preload"> in index.html so Chrome coalesces
                    the preload + picture-source into a single fetch. */}
                <source
                    media="(max-width: 860px)"
                    type="image/webp"
                    srcSet={SNEAKER_TALL_WEBP}
                />
                <img
                    src={SNEAKER_TALL}
                    alt="ALL DESIGN — signature sneaker on lava rock"
                    className="sneaker-hero"
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                />
            </picture>
            <div className="side-overlay side-overlay--greige" />
        </div>
    );
}
